import React, { useEffect, useState } from "react";

export const ResendOtp = ({
  onResend,
  initialSeconds = 30,
  isVisible = true,
  resetKey,
  className = "",
  label = "Resend code",
}) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (!isVisible) return;
    setSecondsLeft(initialSeconds);
  }, [isVisible, initialSeconds, resetKey]);

  useEffect(() => {
    if (!isVisible) return;
    if (secondsLeft <= 0) return;

    const timer = setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [secondsLeft, isVisible]);

  if (!isVisible) return null;

  const disabled = secondsLeft > 0;

  return (
    <div className={className}>
      <button
        type="button"
        className="btn btn-link p-0 font-xsss text-primary"
        onClick={() => {
          if (disabled) return;
          onResend?.();
          setSecondsLeft(initialSeconds);
        }}
        disabled={disabled}
      >
        {label}{disabled ? ` (${secondsLeft}s)` : ""}
      </button>
    </div>
  );
};
